export default __webpack_public_path__ + "static/media/t.aa9f746c.jpg";